import Vue from 'vue'
import Router from 'vue-router'
import VueSweetalert2 from 'vue-sweetalert2'
import _ from 'lodash'

const Home = () => import('@/views/Home')
const Quotation = () => import('@/views/Quotation')
const DocViewer = () => import('@/views/DocViewer')
const QuickQuotation = () => import('@/views/QuickQuotation')
const QuotationPersonal = () => import('@/views/QuotationPersonal')
const InsurancePersonal = () => import('@/views/InsurancePersonal')
const QuotationConfirmation = () => import('@/views/QuotationConfirmation')
const ApplicationConfirmation = () => import('@/views/ApplicationConfirmation')
const TypeFamily = () => import('@/views/TypeFamily')
const InsuranceFamily = () => import('@/views/InsuranceFamily/InsuranceFamily')
const Draft = () => import('@/views/Draft')
const ManageApp = () => import('@/views/ManageApp')
const ReportDaily = () => import('@/views/Report/Daily')
const ReportBranch = () => import('@/views/Report/Branch')
const ReportCountry = () => import('@/views/Report/Country')

const BackOfficeApplicationList = () => import('@/views/BackOffice/Application/List')
const BackOfficeApplicationDetail = () => import('@/views/BackOffice/Application/Detail')

const Authlanding = () => import('@/components/Authlanding')
const Callbacktvi = () => import('@/components/Callbacktvi')
const TviLogin = () => import('@/components/TviLogin')
const TmbLogin = () => import('@/components/TmbLogin')
const Index = () => import('@/views/Index')

const Listrefer = () => import('@/views/Manage/Listrefer')

const PaymentSummary = () => import('@/views/PaymentSummary')
const ConsentInsured = () => import('@/views/ConsentInsured')
const ConsentPayer = () => import('@/views/ConsentPayer')
const QRCodeCheckout = () => import('@/views/QRCodeCheckout')
const BillPaymentCheckout = () => import('@/views/BillPaymentCheckout')
const CreditCardCheckout = () => import('@/views/CreditCardCheckout')
const CreditCardVerify = () => import('@/views/CreditCardVerify')

const PaymentSuccess = () => import('@/views/PaymentSuccess')
const PaymentFailed = () => import('@/views/PaymentFailed')

const NotFound = () => import('@/views/NotFound')

import API from '@/lib/api'
import { PUBLIC_PAGE } from '@/lib/global'
import { generateAuthorizationRequestHeader } from '@/lib/services'

Vue.use(Router, VueSweetalert2)

const router = new Router({
  base: __dirname,
  mode: 'history',
  routes: [
    {
      path: '/callback',
      name: 'callbacktvi',
      component: Callbacktvi,
    },
    {
      path: '/authlanding',
      name: 'authlanding',
      component: Authlanding,
    },
    {
      path: '/tvilogin',
      name: 'tvilogin',
      component: TviLogin,
    },
    {
      path: '/tmblogin',
      name: 'tmblogin',
      component: TmbLogin,
    },
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: Quotation,
    },
    {
      path: '/doc_viewer',
      name: 'DocViewer',
      component: DocViewer,
    },
    {
      path: '/quick_quotation',
      name: 'quick_quotation',
      component: QuickQuotation,
    },
    {
      path: '/quotation_personal',
      name: 'quotation_personal',
      component: QuotationPersonal,
      props: {
        typeInsurance: 'personal',
      },
    },
    {
      path: '/quotation_personal/:quotation_id',
      name: 'quotation_personal_by_id',
      component: QuotationPersonal,
      props: {
        typeInsurance: 'personal',
      },
    },
    {
      path: '/quotation_family/:quotation_id',
      name: 'quotation_family',
      component: QuotationPersonal,
      props: {
        typeInsurance: 'family',
      },
    },
    {
      path: '/quotation-confirmation/:quotation_id',
      name: 'QuotationConfirmation',
      component: QuotationConfirmation,
      props: true,
    },
    {
      path: '/insurance_personal/:application_id',
      name: 'insurance_personal',
      component: InsurancePersonal,
      props: {
        typeInsurance: 'personal',
      },
    },
    {
      path: '/application_family/:application_id',
      name: 'application_family',
      component: InsurancePersonal,
      props: {
        typeInsurance: 'family',
      },
    },
    {
      path: '/application-confirmation/:application_id',
      name: 'ApplicationConfirmation',
      component: ApplicationConfirmation,
      props: true,
    },
    {
      path: '/type_family',
      name: 'type_family',
      component: TypeFamily,
    },
    {
      path: '/insurance_family/:family_id',
      name: 'insurance_family',
      component: InsuranceFamily,
      props: true,
    },
    {
      path: '/draft',
      name: 'draft',
      component: Draft,
    },
    {
      path: '/manage_app',
      name: 'manage_app',
      component: ManageApp,
    },
    {
      path: '/report_daily',
      name: 'report_daily',
      component: ReportDaily,
    },
    {
      path: '/report_branch',
      name: 'report_branch',
      component: ReportBranch,
    },
    {
      path: '/report_district',
      name: 'report_district',
      component: ReportCountry,
    },
    {
      path: '/tvi/issued',
      name: 'tvi_issued',
      component: BackOfficeApplicationList,
    },
    {
      path: '/tvi/issued/:application_id',
      name: 'tvi_issued_policy',
      component: BackOfficeApplicationDetail,
    },
    {
      path: '/manage_referrer',
      name: 'manage_referrer',
      component: Listrefer,
    },
    {
      path: '/payment-summary/:application_id',
      name: 'PaymentSummary',
      component: PaymentSummary,
      props: true,
    },
    {
      path: '/consent/insured/:application_id',
      name: 'ConsentInsured',
      component: ConsentInsured,
      props: true,
    },
    {
      path: '/consent/payer/:application_id',
      name: 'ConsentPayer',
      component: ConsentPayer,
      props: true,
    },
    {
      path: '/payment/bill-payment/:application_id',
      name: 'PaymentBillPayment',
      component: BillPaymentCheckout,
      props: true,
    },
    {
      path: '/payment/qrcode/:application_id',
      name: 'QRCodeCheckout',
      component: QRCodeCheckout,
      props: true,
    },
    {
      path: '/payment/credit-card/:application_id',
      name: 'PaymentCreditCard',
      component: CreditCardCheckout,
      props: true,
    },
    {
      path: '/payment/credit-card/:omise_token/verify',
      name: 'CreditCardVerify',
      component: CreditCardVerify,
      props: true,
    },
    {
      path: '/payment/:type/success/:application_id',
      name: 'PaymentSuccess',
      component: PaymentSuccess,
      props: true,
    },
    {
      path: '/payment/:type/failed/:application_id',
      name: 'PaymentFailed',
      component: PaymentFailed,
      props: true,
    },
    {
      path: '/*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
  scrollBehavior: () => ({ x: 0, y: 0 }),
})

router.beforeEach(({ name: pageName }, from, next) => {
  const isAuthRequired = !_.includes(PUBLIC_PAGE, pageName)

  if (isAuthRequired) {
    const data = {
      headers: {
        ...generateAuthorizationRequestHeader(),
      },
    }
    const url = API.AUTHORIZATION.PAGE_AUTH(pageName)

    router.app.$http.get(url, data)
        .then(res => res.json())
        .then(res => {
          const { statusCode } = res

          return _.eq(statusCode, 200) ? next() : next('/home')
        },
        error => {
          const { body: { statusCode } } = error

          switch (statusCode) {
            case 400:
              return Vue.swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              }).then(() => next('/home'))
            case 401:
              router.app.$session.destroy()
              return next('/')
            case 403:
              return Vue.swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              }).then(() => next('/home'))
          }
        },
      )
  } else {
    return next()
  }
})

export default router
